import React from 'react';

import { Grid, Typography } from '@mui/material';
import { ButtonLink } from '../../../../components/base/ButtonLink';
import { StyledCard } from '../../../../components/StyledCard';

export interface ActionButton {
  to: string;
  text: React.ReactNode;
  className?: string;
  dataCy?: string;
}

export interface Props {
  icon: any;
  title: React.ReactNode;
  content: React.ReactNode;
  actions?: ActionButton[];
}

export function DashboardItem(p: Props) {
  const { icon, title, content, actions = [] } = p;

  const actionComponents =
    actions.length > 0
      ? actions.map((action, index) => (
          <ButtonLink
            key={index}
            size="small"
            to={action.to}
            className={action.className}
            data-cy={action.dataCy}
          >
            {action.text}
          </ButtonLink>
        ))
      : undefined;

  return (
    <Grid item xs={12} sm={6} md={4}>
      <StyledCard avatar={icon} title={title} actions={actionComponents}>
        <Typography variant="body2" color="text.secondary">
          {content}
        </Typography>
      </StyledCard>
    </Grid>
  );
}
